import React, { Component } from "react";
import styled from "styled-components";
import {
    DialogTitle,
    DialogActions,
    Button,
    TextField
} from "@material-ui/core";

import { BeautifulDialog, DialogContent, ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import AddTagsDialog from "js/react/components/Dialogs/AddTagsDialog";
import { Field } from "js/react/components/UiComponents";
import TagsList from "js/react/components/TagsList";
import { t } from "js/i18n";
import { AssetType } from "common/constants";
import { ImageOption, ImageOptionList } from "js/Components/ImageOptionList";

const StyledDialogTitle = styled(DialogTitle)`
    && {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
`;

const TitleText = styled.div`
    color: #333;
    font-size: 23px;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: 0;
`;

const SubText = styled.div`
    color: #666;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.25;
    letter-spacing: 0;
    margin-top: 5px;
`;

const StyledDialogContent = styled(DialogContent)`
    && {
        padding: 0 50px;
        overflow-y: hidden;
    }
`;

const StyledDialogActions = styled(DialogActions)`
    && {
        padding-top: 18px;
    }
`;

const ASSET_TYPE_OPTIONS = [
    {
        label: "Image",
        value: AssetType.IMAGE,
        icon: "camera_alt",
    },
    {
        label: "Logo",
        value: AssetType.LOGO,
        icon: "sort_by_alpha",
    },
];

const AssetTypeOptions = styled(ImageOptionList)`
    && {
        width: max-content;
    }
`;

const AssetTypeOptionsWrapper = styled.div`
    margin-top: 8px;
`;

const TagsListWrapper = styled.div`
    margin-top: 8px;
`;

const AssetTypeOption = styled(ImageOption)`
    && {
        .withlabel label {
            color: #444;
            font-size: 11px;
            font-weight: 600;
            letter-spacing: 0.5px;
            line-height: 1.2;
        }

        .icon {
            min-height: 0;
        }

        .bai-icon {
            font-size: 19px;
        }
    }
`;

class CreateTeamAssetDialogComponent extends Component {
    constructor(props) {
        super(props);

        const { type = "image", name = "", tags = [] } = props;

        this.state = { type, name, tags };
    }

    handleSelectType = async value => {
        this.setState({
            type: value,
        });

        return true;
    }

    handleRemoveTag = tag => {
        const { tags } = this.state;
        let index = tags.indexOf(tag);
        if (index > -1) {
            tags.splice(index, 1);
            this.setState({
                tags,
            });
        }
    }

    handleAddTag = () => {
        let {
            existingTags,
        } = this.props;
        let {
            tags,
        } = this.state;

        ShowDialog(AddTagsDialog, {
            activeTags: tags,
            existingTags,
            acceptCallback: newTags => {
                this.setState({
                    tags: newTags
                });
            },
        });
    }

    handleAccept = () => {
        let {
            callback,
            closeDialog,
        } = this.props;

        !!callback && callback(this.state);
        closeDialog();
    }

    render() {
        const { closeDialog } = this.props;

        let {
            type,
            name,
            tags,
        } = this.state;

        return (
            <BeautifulDialog closeDialog={closeDialog}>
                <StyledDialogTitle>
                    <TitleText>{t("Share this asset with your team?")}</TitleText>
                    <SubText>{t("Update this asset once to update it everywhere it's used.")}</SubText>
                </StyledDialogTitle>

                <StyledDialogContent>
                    <Field title={t("Asset Type")}>
                        <AssetTypeOptionsWrapper>
                            <AssetTypeOptions value={type} onChange={this.handleSelectType} size={34} gap={10}>
                                {ASSET_TYPE_OPTIONS.map(option => (
                                    <AssetTypeOption
                                        key={option.value}
                                        value={option.value}
                                        icon={option.icon}
                                        label={t(option.label)}
                                        labelGap={4}
                                        background="#f7f9fb"
                                    />
                                ))}
                            </AssetTypeOptions>
                        </AssetTypeOptionsWrapper>
                    </Field>
                    <Field title={t("Name")}>
                        <TextField
                            autoFocus
                            id="assetName"
                            value={name}
                            placeholder={t("Asset name...")}
                            fullWidth
                            onChange={event => this.setState({ name: event.target.value })}
                        />
                    </Field>
                    <Field title={t("Tags (optional)")}>
                        <TagsListWrapper>
                            <TagsList
                                tags={tags}
                                onRemove={this.handleRemoveTag}
                                onClick={this.handleAddTag}
                            />
                        </TagsListWrapper>
                    </Field>
                </StyledDialogContent>

                <StyledDialogActions>
                    <Button onClick={closeDialog}>{t("Cancel")}</Button>
                    <Button onClick={this.handleAccept} color="primary" disabled={!name}>{t("Share")}</Button>
                </StyledDialogActions>
            </BeautifulDialog>
        );
    }
}

export default CreateTeamAssetDialogComponent;
